import { useEffect, useState } from "react";
import NavBar from "../../components/NavBar/NavBar";
import logo from "../../assets/oq-logo.png";
import stripePaymentIllustration from "../../assets/stripe-payment-illustration.svg";
import poweredByStripe from "../../assets/poweredByStripe.svg";
import "./SignUpPage.scss";
import { Link, useSearchParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../components/CheckoutForm/CheckoutForm";
import Checkmark from "../../components/Checkmark/Checkmark";
import Footer from "../../components/Footer/Footer";
import axiosClient from "../../axiosClient";
import TermsAndConditions from "../Legal/TermsAndConditions";
import toast from "react-hot-toast";
import PRODUCTS from "./products";
import Button from "../../components/Button/Button";

function SignUpPage() {
  const [stripePromise, setStripePromise] = useState<any>(null);
  const [subscriptionType, setSubscriptionType] = useState<'monthly' | '6_monthly'>("6_monthly");
  const [selectedProducts, setSelectedProducts] = useState<Set<string>>(new Set())
  const [selectedUserType, setSelectedUserType] = useState<'new_user' | 'existing_user'>('new_user');
  const [couponInput, setCouponInput] = useState<string>("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState<boolean>(false);
  const [appliedCoupon, setAppliedCoupon] = useState<null | {
    code: string,
    totalAfter: number,
    discountAmount: number,
    details?: any,
  }>(null);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    const prod = searchParams.get("product");

    if (prod && PRODUCTS.map(p => p.id).includes(prod) && !PRODUCTS.find(p => p.id == prod)?.comingSoon && (PRODUCTS.find(p => p.id == prod) as { showOnSignUp?: boolean })?.showOnSignUp !== false) {
      const cloneSelectedProducts = new Set(selectedProducts);
      cloneSelectedProducts.add(prod);
      setSelectedProducts(cloneSelectedProducts)
    }

    try {
      const fetchStripeConfig = async () => {
        const r = await axiosClient.get('payments/config')
        const { publishableKey } = r.data
        setStripePromise(loadStripe(publishableKey));
      }

      fetchStripeConfig()
    } catch (err) {
      toast.error("Error occured whilst loading page. Please seek support!");
      console.error(err);
    }
  }, []);

  useEffect(() => {
    console.log(subscriptionType);
  }, [subscriptionType])

  const totalPrice = () => {
    let selectedProductIds = Array.from(selectedProducts);
    let products = PRODUCTS.filter(product => selectedProductIds.includes(product.id))
    return products.reduce((sum, product) => sum + product.price, 0);
  }

  const handleApplyCoupon = async (e?: any) => {
    if (e) e.preventDefault();
    const code = couponInput.trim();
    if (!code) return;
    if (selectedProducts.size === 0) {
      toast.error("Please select at least one product first.");
      return;
    }
    try {
      setIsApplyingCoupon(true);
      const selectedProductIds = Array.from(selectedProducts);
      // Validate coupon server-side for security and correct pricing
      const r = await axiosClient.post('payments/oq-validate-coupon', {
        code,
        products: selectedProductIds,
      });
      const data = r.data || {};
      if (data.valid === false) {
        setAppliedCoupon(null);
        toast.error(data?.error || 'Invalid coupon');
        return;
      }
      const subtotal = totalPrice();
      const totalAfter = typeof data.totalAfter === 'number' ? data.totalAfter : subtotal;
      const discountAmount = Math.max(0, subtotal - totalAfter);
      if (discountAmount <= 0) {
        setAppliedCoupon(null);
        toast.error('Coupon does not apply to current selection.');
        return;
      }
      setAppliedCoupon({ code, totalAfter, discountAmount, details: data });
      toast.success('Coupon applied');
    } catch (err: any) {
      console.error(err);
      setAppliedCoupon(null);
      toast.error(err?.response?.data?.error || 'Could not validate coupon');
    } finally {
      setIsApplyingCoupon(false);
    }
  }

  // Clear coupon when product selection changes to avoid stale discounts
  useEffect(() => {
    if (appliedCoupon) {
      setAppliedCoupon(null);
      // subtle notice rather than error
      if (couponInput) {
        toast('Coupon cleared because products changed');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProducts])

  const purchasableProducts = PRODUCTS.filter((p: any) => !p.comingSoon && p.purchasable !== false && p.showOnSignUp !== false);
  const comingSoonProducts = PRODUCTS.filter((p: any) => p.comingSoon && p.showOnSignUp !== false);

  return (
    <>
      <NavBar />
      <div id="SignUpPage">
        <div className="site-container">
          <div className="order-summary-wrapper">
            <div className="order-summary-inner">
              {/* <div className="big-logo-wrapper">
                <img src={logo} className="big-logo" alt="" />
              </div> */}

              <div className="inner-cols-wrapper">
                <div className="order-summary-col">
                  <form id="form-wrapper">
                    <h3 className="order-summary-section-title">
                      Purchase Form
                    </h3>

                    <h5 style={{
                      marginTop: '50px'
                    }}>Products</h5>

                    <p>Please select all the products you wish to purchase.</p>

                    {purchasableProducts.map(product => {
                      let className = "oq-product-card-wrapper";

                      if (selectedProducts.has(product.id)) {
                        className += " oq-product-card-wrapper-selected"
                      }

                      return (
                        <div>
                          <div className={className} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const cloneSelectedProducts = new Set(selectedProducts);
                            if (cloneSelectedProducts.has(product.id)) {
                              cloneSelectedProducts.delete(product.id);
                            } else {
                              cloneSelectedProducts.add(product.id);
                            }
                            setSelectedProducts(cloneSelectedProducts);
                          }}>
                            <div>
                              <input name={product.id} id={product.id} type="checkbox" checked={selectedProducts.has(product.id)} style={{
                                marginRight: '10px'
                              }} />
                              <label htmlFor={product.id}>{product.title}: <span>£{product.price}</span> / {product.length}</label>
                            </div>
                            <div></div>
                          </div>
                        </div>
                      )
                    })}


                    {comingSoonProducts.length > 0 && (
                      <>
                        <h6 style={{
                          marginTop: '50px'
                        }}>Products coming soon:</h6>
                        <p>The products below will be available to purchase soon.</p>
                        {comingSoonProducts.map(product => {
                          let className = "oq-product-card-wrapper oq-product-card-wrapper-coming-soon";
                          let priceLabel;
                          if (product.price) {
                            priceLabel = <label htmlFor={product.id}>{product.title}: <span>£{product.price}</span> / {product.length}</label>;
                          }
                          else {
                            priceLabel = <label htmlFor={product.id}>{product.title}: <span>(price to be confirmed)</span> </label>
                          }
                          return (
                            <div>
                              <div className={className} title="This product is not available for purchase yet." onClick={(e) => {
                                e.preventDefault();
                                toast("This product is not available for purchase yet, but we intend to have it ready soon.")
                              }}>
                                <div>
                                  <input name={product.id} id={product.id} type="checkbox" checked={selectedProducts.has(product.id)} style={{
                                    marginRight: '10px'
                                  }} />
                                  {priceLabel}
                                </div>
                                <span className="coming-soon">coming soon</span>
                              </div>
                            </div>
                          )
                        })}
                      </>
                    )}

                    {/* <p style={{
                      fontSize: 'smaller',
                      marginTop: '25px'
                    }}><strong>NOTE:</strong>You may select more than one product, and you may purchase additional ones after you've signed up too.</p> */}

                    {selectedProducts.size > 0 && (
                      <div id="totalPrice"
                        style={{
                          borderTop: '1px solid #f3f3f3',
                          borderBottom: '1px solid #f3f3f3',
                          paddingTop: 20,
                          paddingBottom: 15,
                        }}
                      >
                        {!appliedCoupon && (
                          <h2>Total: <span style={{
                            color: 'navy',
                          }}>£{totalPrice()}</span> <span style={{
                            fontSize: '16px'
                          }}>due today</span>
                          </h2>
                        )}
                        {appliedCoupon && (
                          <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                              <span>Subtotal</span>
                              <span>£{totalPrice()}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, color: 'green' }}>
                              <span>Coupon ({appliedCoupon.code})</span>
                              <span>-£{appliedCoupon.discountAmount}</span>
                            </div>
                            <h2>
                              Total: <span style={{ color: 'navy' }}>£0</span> <span style={{ fontSize: '16px' }}>due today</span>
                            </h2>
                          </div>
                        )}
                      </div>
                    )}

                    {selectedProducts.size > 0 && (
                      <div className="coupon-section">
                        <h5>Coupon</h5>
                        {!appliedCoupon && (
                          <div className="coupon-row">
                            <input
                              className="coupon-input"
                              type="text"
                              placeholder="Enter coupon code"
                              value={couponInput}
                              onChange={(e) => setCouponInput(e.target.value)}
                            />
                            <div className="coupon-apply-button">
                              <Button
                                text={isApplyingCoupon ? "Applying…" : "Apply"}
                                disabled={isApplyingCoupon || !couponInput.trim()}
                                type="navy"
                                onClick={handleApplyCoupon}
                              />
                            </div>
                          </div>
                        )}
                        {appliedCoupon && (
                          <div className="applied-coupon-row">
                            <span>Applied coupon: <strong>{appliedCoupon.code}</strong></span>
                            <button className="remove-coupon" type="button" onClick={() => setAppliedCoupon(null)}>Remove</button>
                          </div>
                        )}
                      </div>
                    )}

                    <div style={{
                      paddingTop: 30,
                    }}>

                      <h5>User type</h5>

                      <p style={{
                        marginBottom: '5px'
                      }}>Please select if you are a new user or an existing user.</p>

                      <div id="user-types-wrapper">
                        <label htmlFor="new-user" className={`user-type ${selectedUserType === 'new_user' ? 'active' : ''}`}>
                          <input id="new-user" name="new-user" type="checkbox" checked={selectedUserType === 'new_user'} onChange={() => setSelectedUserType('new_user')} />
                          I am a new user
                        </label>

                        <label htmlFor="existing-user" className={`user-type ${selectedUserType === 'existing_user' ? 'active' : ''}`}>
                          <input id="existing-user" name="existing-user" type="checkbox" checked={selectedUserType === 'existing_user'} onChange={() => setSelectedUserType('existing_user')} />
                          I am an existing user
                        </label>
                      </div>

                    </div>

                    <h4 className="order-summary-section-title">
                      {selectedUserType === 'new_user' ? 'Sign up Details' : 'Login details'}
                    </h4>

                    <div className="user-details-section">
                      <h5 style={{
                        // marginTop: '30px'
                      }}>Your details</h5>


                      {selectedUserType === 'new_user' && (
                        <div className="user-details-name-wrapper">
                          <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            required
                          />
                          <input
                            type="text"
                            name="surname"
                            placeholder="Surname"
                            required
                          />
                        </div>
                      )}


                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Email"
                        required
                      />

                      <input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Password"
                        autoComplete="new-password"
                        required
                      />

                      {selectedUserType === 'new_user' && (
                        <input
                          type="password"
                          name="confirmPassword"
                          id="confirmPassword"
                          placeholder="Confirm password"
                          required
                        />
                      )}
                    </div>

                    <div style={{
                      display: 'flex',
                      marginBottom: '30px',
                    }}>
                      <input type="checkbox" name="agree_to_terms" id="agree_to_terms" style={{
                        marginRight: '5px'
                      }} defaultChecked={false} required />
                      <label htmlFor="agree_to_terms" style={{
                        position: 'relative',
                        top: '12px'
                      }}>I agree to OphthalmologyQ's <a href="/terms-and-conditions" target="_blank">Terms and Conditions</a>, <a href="/terms-of-use" target="_blank">Terms of Use</a>,
                        and our <a href="privacy-policy" target="_blank">Privacy Policy</a>.</label>
                    </div>

                    <h4 className="order-summary-section-title">
                      Billing Details
                    </h4>

                    <div className="billing-details-section">
                      {stripePromise && (
                        <Elements
                          stripe={stripePromise}
                          options={{
                            mode: "subscription",
                            amount: 10000, // TODO: what is this???!
                            currency: "gbp",
                            // Fully customizable with appearance API.
                            // appearance: {/*...*/},
                          }}
                        >
                          <CheckoutForm products={Array.from(selectedProducts)} isNewUser={selectedUserType === 'new_user'} couponCode={appliedCoupon?.code} />
                        </Elements>
                      )}
                    </div>
                  </form>
                </div>

                <div className="key-features-col">
                  <h3 className="key-features-title">Key Features</h3>

                  <div className="key-features-list-wrapper">
                    <ul>
                      <li>
                        <Checkmark />
                        Created by Ophthalmologist for Ophthalmologists
                      </li>
                      <li>
                        <Checkmark />
                        Extensive content with 1000s of questions overall
                      </li>
                      <li>
                        <Checkmark />
                        Covers Duke Elder Examination, FRCOphth Parts 1 & 2, & Refraction Exam
                      </li>
                      <li>
                        <Checkmark />
                        Regular updates to platform and questions
                      </li>
                      {/* <li>
                        <Checkmark />
                        4000+ hand-crafted questions by professionals
                      </li> */}
                    </ul>
                  </div>

                  {/* <img
                    src={stripePaymentIllustration}
                    className="stripe-payment-illustration"
                    alt=""
                  /> */}
                  <img
                    src={poweredByStripe}
                    alt="Powered by Stripe.com"
                    id="powered-by-stripe"
                  />
                  <p id="please-contact-us">
                    Please contact{" "}
                    <Link to={"/contact-us"}>ali.hejazi@masterq.co.uk</Link> for any
                    support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SignUpPage;
